function toString(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
export function isArray(value) {
    return toString(value) === 'Array';
}
export function isObject(value) {
    return toString(value) === 'Object';
}
export function isError(value) {
    return toString(value) === 'Error';
}
export function isNotEmptyObject(value) {
    return isObject(value) && Object.keys(value).length > 0;
}
export function isFunction(value) {
    return (typeof value) === 'function';
}
export function isBoolean(value) {
    return (typeof value) === 'boolean';
}
export function isNull(value) {
    return toString(value) === 'Null';
}
export function isString(value) {
    return (typeof value) === 'string';
}
export function isUndefined(value) {
    return toString(value) === 'Undefined';
}
//# sourceMappingURL=check.js.map